import { getWishList } from '../../api/login'

const wish = {
  state: {
    wishList: {} // 관심 상품 목록
  },

  mutations: {
    SET_WISHLIST: (state, wishList) => {
      state.wishList = wishList
    }
  },
  actions: {
    // 관심상품 가져오기
    GetWishList({ commit, state }, userId) {
      return new Promise((resolve, reject) => {
        getWishList(userId)
          .then(response => {
            commit('SET_WISHLIST', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default wish



// WEBPACK FOOTER //
// ./src/store/modules/wish.js